// extracted by mini-css-extract-plugin
export var btn = "SegmentsSection-module--btn--730e2";
export var businessSolutions = "SegmentsSection-module--business-solutions--a9c37";
export var card = "SegmentsSection-module--card--ad9a1";
export var cards = "SegmentsSection-module--cards--3994b";
export var core = "SegmentsSection-module--core--cb54f";
export var publicSolutions = "SegmentsSection-module--public-solutions--e07f5";
export var residentialSolutions = "SegmentsSection-module--residential-solutions--02e2f";
export var slider = "SegmentsSection-module--slider--5102a";